import React, {useEffect} from 'react';
import styles from './AdminProjectNote.module.css';
import Button from "../../common/button/Button";
import {useNavigate} from "react-router-dom";
import {adminProjectNoteAPI, adminProjectNoteImageAPI} from "../../../services/admin";
import {AdminProjectNoteResponseData} from "../../../types/admin";
import {EyeIcon, EyeSlashIcon} from "@heroicons/react/24/solid";
import logo from '../../../assets/covi_logo_white.png';

interface AdminProjectNoteProps {
    projectId: number;
}

//어드민 프로젝트 특이사항
const AdminProjectNote: React.FC<AdminProjectNoteProps> = ({projectId}) => {
    const [data, setData] = React.useState<AdminProjectNoteResponseData | null>(null);
    const [image, setImage] = React.useState<string>();
    const [loading, setLoading] = React.useState(true);
    const navigate = useNavigate();

    //프로젝트 특이사항 수정 페이지 이동
    const handleEdit = () => {
        navigate(`/admin/projects/note/${projectId}/edit`);
    };

    const fetchData = async () => {
        try {
            setLoading(true);
            //어드민 프로젝트 특이사항 조회 API
            const response = await adminProjectNoteAPI(projectId);
            setData(response);
            //특이사항 이미지 조회 API
            const file = await adminProjectNoteImageAPI(projectId);
            //파일 내부 URL 생성
            const url = URL.createObjectURL(file);
            setImage(url);
        } catch (error) {
            console.error('Error fetching project request:', error);
        } finally {
            setLoading(false);
        }
    };

    //특이사항 공개 여부 아이콘
    const publicIcon = (isPublic: boolean | undefined) => {
        if (isPublic) {
            //공개 시
            return (
                <div className={styles.icon}>
                    <span>공개</span>
                    <EyeIcon/>
                </div>
            )
        }
        //비공개 시
        return (
            <div className={styles.icon}>
                <span>비공개</span>
                <EyeSlashIcon/>
            </div>
        )
    }

    useEffect(() => {
        fetchData();
    }, [projectId]);

    if (loading) {
        return <div className={styles.loading}>Loading...</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h1 className={styles.title}>Project Note</h1>
                <p className={styles.subtitle}>프로젝트 특이사항</p>
                {/*프로젝트 특이사항 수정 버튼*/}
                <Button
                    variant="primary"
                    size="small"
                    className={styles.submitButton}
                    onClick={handleEdit}
                >
                    수정
                </Button>
            </div>

            <div className={styles.mainContent}>
                <div className={styles.leftSection}>
                    <div className={styles.imageContainer}>
                        {/*프로젝트 특이사항 이미지*/}
                        {image ? (
                            <img
                                src={image}
                                alt="Project Request Preview"
                                className={styles.image}
                                onError={(e) => {
                                    e.currentTarget.src = logo;
                                }}
                            />
                        ) : (
                            <div className={styles.noImage}>No image available</div>
                        )}
                    </div>
                    <div className={styles.projectTitle}>
                        {/*프로젝트 제목*/}
                        {data?.projectName || 'Project'}
                        <div className={styles.publicStatus}>
                            특이사항 공개 여부
                            {publicIcon(data?.isPublic)}
                        </div>
                    </div>
                </div>

                <div className={styles.leftNote}>
                    <div className={styles.noteContent}>
                        {data?.note}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AdminProjectNote;